/**
 * SearchBar component with debounced search
 */

import React, { useState, useCallback, useRef } from "react";
import { debounce } from "../lib/search";
import type { SearchBarProps } from "../types/index";

export default function SearchBar({
  onSearch,
  isLoading = false,
  placeholder = "Search skills...",
}: SearchBarProps): JSX.Element {
  const [query, setQuery] = useState("");
  const onSearchRef = useRef(onSearch);
  onSearchRef.current = onSearch;
  const debouncedSearch = useCallback(debounce((q: string) => onSearchRef.current(q), 300), []);

  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const value = e.currentTarget.value;
    setQuery(value);
    debouncedSearch(value);
  };

  return (
    <div style={{ marginBottom: "2rem" }}>
      <div style={{ position: "relative" }}>
        <input
          type="text"
          value={query}
          onChange={handleChange}
          placeholder={placeholder}
          disabled={isLoading}
          style={{
            width: "100%",
            padding: "0.75rem",
            fontSize: "1rem",
            border: "1px solid #ddd",
            borderRadius: "8px",
            boxSizing: "border-box",
            opacity: isLoading ? 0.6 : 1,
            cursor: isLoading ? "wait" : "text",
          }}
        />
        {isLoading && (
          <span
            style={{
              position: "absolute",
              right: "1rem",
              top: "50%",
              transform: "translateY(-50%)",
              color: "#999",
              fontSize: "0.9rem",
            }}
          >
            Loading...
          </span>
        )}
      </div>
      {query && (
        <p style={{ margin: "0.5rem 0 0 0", color: "#666", fontSize: "0.9rem" }}>
          Searching for "{query}"
        </p>
      )}
    </div>
  );
}
